export const dataPersonName = {
  type: 'string',
};
